import firebase from "../firebase";

export default function({accessCode}) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "user",
        funcName: "signInCode",
        data: {accessCode}
    });
}
